import * as React from "react";
const ChemicalIntermediatesSVG = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      fill="rgba(238, 65, 55, 1)"
      d="M20.423 17.713 15 10.256V3h1.5V1.5h-9V3H9v7.256l-5.423 7.457A3.014 3.014 0 0 0 6.014 22.5h11.971a3.014 3.014 0 0 0 2.438-4.787m-9.923-6.97V3h3v7.744l2.005 2.756h-7.01l2.005-2.756ZM17.986 21H6.015a1.515 1.515 0 0 1-1.225-2.404L7.405 15h9.19l2.616 3.596A1.515 1.515 0 0 1 17.985 21Z"
    />
  </svg>
);
export default ChemicalIntermediatesSVG;
